<template>
  <div>
    <div class="gw-top margin-bottom">
      <h3 class="margin-bottom-xs">{{ practiceForm.sx_name }}</h3>
      <h4 v-if="practiceForm.salary_min && practiceForm.salary_max">{{ (practiceForm.salary_min / 1000).toFixed(2) }}K
        - {{ (practiceForm.salary_max / 1000).toFixed(2) }}K</h4>
      <h4 v-else>无薪资</h4>
      <p>
        招募人数：{{ practiceForm.stu_num }}
        <span class="padding-lr-xs">|</span>
        实习时间：{{ practiceForm.shixi_time }}
      </p>
    </div>
    <div class="flex align-start justify-between padding-lr-sm">
      <div class="basis-lg gw-detail">
        <div>
          <h3>岗位职责</h3>
          <p>{{ practiceForm.zhize }}</p>
        </div>
        <div>
          <h3>入职条件</h3>
          <p>{{ practiceForm.tiaojian }}</p>
        </div>
        <div>
          <h3>入职要求</h3>
          <p>{{ practiceForm.yaoqiu }}</p>
        </div>
        <div>
          <h3>其他补贴待遇</h3>
          <p>{{ practiceForm.daiyu }}</p>
        </div>
        <div>
          <h3>工作地址</h3>
          <p>{{ practiceForm.address }}</p>
        </div>

        <div v-if="practiceForm.remark">
          <h3>备注</h3>
          <p>{{ practiceForm.remark }}</p>
        </div>


      </div>
      <div class="basis-xm org-detail" v-if="org">
        <div class="flex align-center margin-bottom">
          <img :src="imgUrl + org.logo" alt="" width="100px" height="100px" class="margin-right">
          <h3>{{ org.org_name }}</h3>
        </div>

        <p>{{ org.desc }}</p>
        <p>{{ org.address }}</p>
        <p>联系人：{{ org.name }}</p>
        <p>联系人手机号：{{ org.phone }}</p>
        <p>联系人邮箱：{{ org.email }}</p>
        <p>官网地址： <el-link type="primary" :href="org.site_url " target="_blank">{{ org.site_url }}</el-link></p>
        <p>机构环境:</p>
        <div class="flex align-center flex-wrap">
          <el-image
              class="margin-right-xs margin-bottom-xs"
              v-for="(item,index) in org.env_img"
              :key="index"
              style="width: 80px; height: 80px"
              :src="item"
              :preview-src-list="org.env_img">
          </el-image>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {IMGURL} from "@/config";
import {getOrgDesc, station} from "@/api/practiceBase";

export default {
  name: "jobDetail",
  data() {
    return {
      practiceForm: {
        sx_name: '',
        salary_min: 0,
        salary_max: 0,
        address: '',
        stu_num: '',
        shixi_time: '',
        end_time: '',
        zhize: '',
        tiaojian: '',
        yaoqiu: '',
        daiyu: '',
        remark: ''
      },
      imgUrl: IMGURL,
      org: null,
    }
  },
  props:{
    id:{
      type:Number
    }
  },
  created() {
    this.getDetail()
  },
  components: {},
  methods: {
    async getDetail() {
      let _data = await station(this.$route.query.id)
      this.practiceForm = {
        sx_name: _data.data.sx_name,
        address: _data.data.address,
        salary_min: Number(_data.data.salary_min),
        salary_max: Number(_data.data.salary_max),
        stu_num: _data.data.stu_num,
        shixi_time: _data.data.shixi_time,
        end_time: new Date(_data.data.end_time),
        zhize: _data.data.zhize,
        tiaojian: _data.data.tiaojian,
        yaoqiu: _data.data.yaoqiu,
        daiyu: _data.data.daiyu,
        remark: _data.data.remark,
      }
      let _org = await getOrgDesc(this.$route.query.id)
      _org.data.env_img = _org.data.env_img.split(',')
      let _arr = []
      _org.data.env_img.map(item => {
        _arr.push(this.imgUrl + item)
      })
      this.org = _org.data
      this.org.env_img = _arr
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.gw-top {
  padding: 20px;
  background-color: #f5faff;

  h3 {
    font-size: 26px;
    line-height: 150%;
  }

  h4 {
    font-size: 24px;
    color: #009688;
    line-height: 150%;
  }

  p {
    color: #666;
    line-height: 150%;
  }
}

.gw-detail {
  padding: 20px;
  border: 1px solid #eee;

  div {
    margin-bottom: 30px;

    h3 {
      font-size: 16px;
      color: #009688;
      margin-bottom: 10px;
    }

    p {
      text-indent: 28px;
      line-height: 30px;
    }
  }
}

.org-detail {
  padding: 20px;
  border: 1px solid #eee;
  >img{
    margin-bottom: 20px;
  }
  h3{
    font-size: 18px;
    line-height: 36px;
  }
  p{
    line-height: 28px;
    margin-bottom: 15px;
  }
}
</style>